import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid-order-from-home',
  templateUrl: './covid-order-from-home.component.html',
  styleUrls: ['./covid-order-from-home.component.less']
})
export class CovidOrderFromHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  
  toggleAccordian(event:any){
    console.log('toggleAccordian running')
    console.log(event)
    let elem = event.srcElement;
    let spanElem = elem.children[0];
    let iconElem = spanElem.children[0];
    if (iconElem.classList.contains('fa-chevron-right')) {
      iconElem.classList.replace('fa-chevron-right', 'fa-chevron-down');
    } else {
      iconElem.classList.replace('fa-chevron-down', 'fa-chevron-right');
    }
  }
}
